// extracted by mini-css-extract-plugin
export default {"container":"bidConfirmation_container__toVqE","content":"bidConfirmation_content__n8+FT"};